// Compatibility shim for DB module
// Re-export everything from the implementation file

import * as impl from './indexDB.impl'

export * from './indexDB.impl'
export default impl

// CommonJS interop for consumers using require()
try {
  // eslint-disable-next-line no-undef
  module.exports = impl
} catch {}